export default __webpack_public_path__ + "img/f814076d89050b8b6a7326c79b7158e0.svg";